import { useMutation, useQueryClient } from '@tanstack/react-query';

import { feedbackClient } from '../client/feedbackClient';
import { cacheKeys } from '../config';


type Options = {
  onCompleted?: () => void;
};

export const useFeedbackCrud = ({ onCompleted }: Options = {}) => {
  const queryClient = useQueryClient();

  const answerQuestion = useMutation({
    mutationKey: [cacheKeys.answerFeedbackQuestion],
    mutationFn: (data: { sessionId: number; questionId: number; answer: Feedback.AnswerValue }) =>
      feedbackClient.answerQuestion(data),
    // Mid-session cache is intentionally not invalidated — the optimistic
    // `locallyAnswered` set in the UI keeps answered questions out of the
    // queue until the whole session completes, avoiding a flicker.
    onSettled: (response) => {
      if (response?.data?.completed) {
        queryClient.invalidateQueries({ queryKey: [cacheKeys.getOngoingFeedbackSession] });
        onCompleted?.();
      }
    },
  });

  return { answerQuestion };
};
